export const SHOW_ACTUAL_VALUE_FOR_CURRENT_SEGMENT = false; // If true, will show actual value for current segment in charts / forecasts
export const APPLY_BUDGET_PATCHES_TO_PAST_SEGMENTS = true; // If true, will apply budget patches to past segments
// export const ALWAYS_SHOW_PATCHED_VALUE_FOR_CURRENT_SEGMENT = true; // If true, will show patched value even if it's not the most recent value

// If true, will prefer current balance over available balance when calculating/displaying account values
export const PREFER_CURRENT_BALANCE_OVER_AVAILABLE_BALANCE = true;
